import { IAppState } from '../types';

export const getProgress = (state: IAppState) => {
  if (state.finalized) return 100;
  return (state.activeCard / state.totalCards) * 100;
};

export const isFinalQuestion = (state: IAppState) => {
  return state.activeCard + 1 === state.totalCards;
};
